import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminNav from '../components/admin/AdminNav';
import AdminDashboard from '../components/admin/AdminDashboard';
import TreesList from '../components/admin/TreesList';
import AdminReports from '../components/admin/AdminReports';
import AdminStatistics from '../components/AdminStatistics';
import AdminLogs from '../components/AdminLogs';
import AdminSettings from '../components/admin/AdminSettings';
import ContestStatus from '../components/admin/ContestStatus';
import ErrorBoundary from '../components/ErrorBoundary';

export default function Admin() {
  return (
    <div className="min-h-screen bg-gray-50">
      <AdminNav />
      
      <main className="container mx-auto px-4 py-8">
        <ErrorBoundary>
          <div className="mb-8">
            <ContestStatus />
          </div>
          <Routes>
            <Route index element={<AdminDashboard />} />
            <Route path="trees" element={<TreesList />} />
            <Route path="reports" element={<AdminReports />} />
            <Route path="statistics" element={<AdminStatistics />} />
            <Route path="logs" element={<AdminLogs />} />
            <Route path="settings" element={<AdminSettings />} />
          </Routes>
        </ErrorBoundary>
      </main>
    </div>
  );
}